import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const setHeights = () => {
  document.querySelectorAll(".element-scrollableslider").forEach((el) => {
    const slidesContainer = el.querySelector(".slides-container");
    const slides = el.querySelectorAll(".slide");

    const maxHeight = Array.from(slides).reduce((maxHeight, slide) => {
      const slideHeight = slide.offsetHeight;
      return Math.max(maxHeight, slideHeight);
    }, 0);

    slidesContainer.style.minHeight = `${maxHeight}px`;
  });
};

document.querySelectorAll(".element-scrollableslider").forEach((el) => {
  const slidePos = el.querySelector(".slide-pos");
  const slidePosIndex = el.querySelector(".slide-pos-index");
  const slides = el.querySelectorAll(".slide");
  const numSlides = slides.length;

  const slidesTimeline = gsap.timeline({
    paused: true,
  });

  slides.forEach((slide, index) => {
    slidesTimeline.to(slide, { opacity: 1 });

    if (index === numSlides - 1) {
      slidesTimeline.to(slide, { opacity: 1 });
    } else {
      slidesTimeline.to(slide, { opacity: 0 });
    }
  });

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el.querySelector(".element-container"),
      start: () => {
        const siteHeaderHeight = document.querySelector(".site-header").offsetHeight;

        return `top ${siteHeaderHeight}`;
      },
      end: `bottom+=${numSlides * 50}% top`,
      scrub: 1.5,
      pin: true,
      markers: false,
      onUpdate: (scrollTrigger) => {
        slidesTimeline.progress(scrollTrigger.progress + 0.1);
      },
    },
  });

  timeline.to(slidePosIndex, {
    y: () => {
      const posRect = slidePos.getBoundingClientRect();
      const indexRect = slidePosIndex.getBoundingClientRect();

      return posRect.bottom - indexRect.bottom;
    },
  });
});

setHeights();

window.addEventListener("resize", setHeights);
